import { EntityStatus, ProductStatus } from '@/api';

export class StatusUtil {
	public static getPriority(status?: ProductStatus): number {
		switch (status) {
			case ProductStatus.Live:
				return 0;
			case ProductStatus.SignOff:
				return 1;
			case ProductStatus.Install:
				return 2;
			case ProductStatus.Pending:
				return 3;
			case ProductStatus.Draft:
				return 4;
			case ProductStatus.Removed:
				return 5;
			case ProductStatus.Cancelled:
				return 6;
			default:
				return 7;
		}
	}
}
